var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('router-link',{staticClass:"report-link btn-primary",attrs:{"to":("/report/" + _vm.primaryReportId + "/folder/" + _vm.hgFolderId)}},[_vm._v(" View Report ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }